<template>
  <div class="map-box">
    <div id="container" style="height: 400rpx; overflow: hidden"></div>

    <div class="search-box">
      <el-input
        v-model="address"
        placeholder="请输入需要查询的地址"
        style="width: 500px"
        @click.stop
      ></el-input>
      <el-button
        type="primary"
        class="ml-30px"
        @click.stop="setAddress(address)"
        >查询</el-button
      >
    </div>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  props: {
    coordinate: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    coordinate: {
      handler(val) {
        console.log('utils.isEmptyObj(val) :>> ', utils.isEmptyObj(val))
        if (!utils.isEmptyObj(val)) {
          this.query.lat = val.lat ? val.lat : 23.163557
          this.query.lng = val.lng ? val.lng : 113.430595
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      geocoder: null,
      center: null,
      marker: null,
      map: null,
      query: {
        lat: 23.163557,
        lng: 113.430595
      },
      address: ''
    }
  },
  methods: {
    init() {
      // 定义地图中心点坐标
      // eslint-disable-next-line no-undef, no-var
      this.center = new TMap.LatLng(this.query.lat, this.query.lng)
      // 定义map变量，调用 TMap.Map() 构造函数创建地图
      // eslint-disable-next-line no-undef
      this.map = new TMap.Map(document.getElementById('container'), {
        center: this.center, // 设置地图中心点坐标
        zoom: 17, // 设置地图缩放级别
        pitch: 43.5, // 设置俯仰角
        rotation: 45, // 设置地图旋转角度
        viewMode: '2D'
      })
      // eslint-disable-next-line no-undef
      this.geocoder = new TMap.service.Geocoder() // 新建一个正逆地址解析类
      // eslint-disable-next-line no-unused-vars, no-undef
      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          // 点标记样式
          // eslint-disable-next-line no-undef
          marker: new TMap.MarkerStyle({
            width: 20, // 样式宽
            height: 30, // 样式高
            anchor: { x: 10, y: 30 } // 描点位置
          })
        },
        geometries: [
          // 点标记数据数组
          {
            // 标记位置(纬度，经度，高度)
            position: this.center,
            id: '1'
          }
        ]
      })
      // eslint-disable-next-line no-unused-vars
      const centerLatLng = this.map.getCenter()

      this.map.on('click', (evt) => {
        console.log('evt :>> ', evt)
        const { lat, lng } = evt.latLng
        this.marker.remove(['1'])
        this.marker.add([
          {
            id: '1', // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            // eslint-disable-next-line no-undef
            position: new TMap.LatLng(lat, lng), // 点标记坐标位置
            properties: {}
          }
        ])
        // if (!evt.poi) return this.$message.warning('该位置是无效地址')
        this.$emit('latlng', evt.latLng)
        this.getAddress(evt.latLng)
        console.log('result :>> ', evt.latLng)
      })
    },
    setAddress(address) {
      this.marker.remove(['1'])
      // 将给定的地址转换为坐标位置
      this.geocoder
        .getLocation({ address })
        .then((result) => {
          this.marker.add([
            {
              id: '1', // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              position: result.result.location // 点标记坐标位置
            }
          ])
          this.map.setCenter(result.result.location)
          // this.$emit('latlng', result.result.location)
          console.log('result :>> ', result.result.location)
          // document.getElementById('location').value = result.result.location.toString()
          // 显示坐标数值
        })
        .catch(() => {
          this.$message.error('请输入正确的地址')
        })
    },
    getAddress(location) {
      this.marker.remove(['1'])
      // 将给定的地址转换为坐标位置
      this.geocoder
        .getAddress({ location })
        .then((result) => {
          this.marker.add([
            {
              id: '1', // 点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              position: result.result.location // 点标记坐标位置
            }
          ])
          this.map.setCenter(result.result.location)
          this.$emit('address', result.result.formatted_addresses.recommend)
          console.log('result2 :>> ', result, result.address)
        })
        .catch(() => {
          this.$message.error('请输入正确的地址')
        })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.map-box {
  position: relative;
  .search-box {
    pointer-events: auto; 
    width: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 2000;
  }
}
</style>
